var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.022 25.67v-3.668a.547.547 0 0 0-.16-.387l-15.61-15.61a.547.547 0 0 0-.388-.16H6.196a.329.329 0 0 0-.329.328V9.58c0 .146.058.284.161.387l5.603 5.603a.329.329 0 0 1 0 .465l-5.667 5.667a.33.33 0 0 0-.097.233v3.735c0 .18.148.328.329.328h6.13a.329.329 0 0 0 .328-.328v-2.2a.33.33 0 0 1 .097-.233l3.04-3.04a.328.328 0 0 1 .464 0l5.642 5.641c.103.103.242.161.387.161h3.409a.329.329 0 0 0 .328-.328v-.001Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE7A30",
    d: "M17.845 10.703h3.07a.33.33 0 0 1 .33.33v3.07a.33.33 0 0 0 .565.234l4.212-4.219a.33.33 0 0 0 .097-.233V6.191a.33.33 0 0 0-.33-.33l-3.75-.006a.334.334 0 0 0-.234.097l-4.194 4.187a.33.33 0 0 0 .233.564h.001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/logo4.d4b0736e5891b5b92b5795bfd88137c7.svg";
export { ForwardRef as ReactComponent };